export enum EqFilterType {
	HighCut = 'HIGH_CUT',
	HighShelf = 'HIGH_SHELF',
	LowCut = 'LOW_CUT',
	LowShelf = 'LOW_SHELF',
	Parametric = 'PARAMETRIC'
}
